import { alpha, Box, Typography } from '@mui/material';
import { ShowChart as ShowChartIcon } from '@mui/icons-material';
import { BreadthMetric, C, fmtPct, toneToColor } from './shared';

export default function MarketInternalsPanel({ t, summary, internalBreadth, indexContext }) {
  const divergenceTone = toneToColor(indexContext?.read?.tone);
  const indexCompareText = t('bottomingFlow.marketInternals.indexCompare', {
    equalWeight: fmtPct(indexContext.equal_weight_return_20d_pct, 1),
    vnindex: fmtPct(indexContext.vnindex_return_20d_pct, 1),
  });

  return (
    <Box sx={{ border: `1px solid ${C.borderSoft}`, borderRadius: 1.5, bgcolor: '#fff', overflow: 'hidden', boxShadow: '0 8px 24px rgba(15,23,42,0.04)' }}>
      <Box sx={{ px: 1.5, pt: 1, pb: 0.65, display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1.2, flexWrap: 'wrap', background: 'linear-gradient(180deg, rgba(248,250,252,0.9) 0%, rgba(255,255,255,1) 100%)' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.8, minWidth: 0 }}>
          <ShowChartIcon sx={{ fontSize: 16, color: '#64748b' }} />
          <Typography sx={{ fontSize: '0.78rem', fontWeight: 800, color: C.ink }}>
            {t('bottomingFlow.marketInternals.title')}
          </Typography>
          <Typography sx={{ fontSize: '0.68rem', color: C.inkSoft }}>
            {t('bottomingFlow.marketInternals.subtitle')}
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.6, px: 0.85, py: 0.45, borderRadius: 1, bgcolor: alpha(divergenceTone, 0.08), color: divergenceTone }}>
          <Typography sx={{ fontSize: '0.68rem', fontWeight: 900 }}>
            {indexContext?.read?.label_key ? t(indexContext.read.label_key) : '-'}
          </Typography>
          <Typography sx={{ fontSize: '0.64rem', color: C.inkSoft }}>
            {indexCompareText}
          </Typography>
        </Box>
      </Box>
      <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, 1fr)', lg: 'repeat(5, 1fr)' }, gap: 0.8, p: 1 }}>
        <BreadthMetric label={t('bottomingFlow.marketInternals.accumulation')} value={fmtPct(internalBreadth.accumulation_pct, 1)} sub={t('bottomingFlow.marketInternals.stockCount', { count: summary?.universe?.total || 0 })} color={C.accumulation} />
        <BreadthMetric label={t('bottomingFlow.marketInternals.baseCompression')} value={fmtPct(internalBreadth.base_compression_pct, 1)} sub={t('bottomingFlow.marketInternals.rangeTight')} color={C.bottoming} />
        <BreadthMetric label={t('bottomingFlow.marketInternals.tightRange')} value={fmtPct(internalBreadth.tight_range_pct, 1)} sub={t('bottomingFlow.marketInternals.twentySessions')} color={C.sky} />
        <BreadthMetric label={t('bottomingFlow.marketInternals.distribution')} value={fmtPct(internalBreadth.distribution_pct, 1)} sub={t('bottomingFlow.marketInternals.exitRisk')} color={C.distribution} />
        <BreadthMetric label={t('bottomingFlow.marketInternals.spotlight')} value={fmtPct(internalBreadth.spotlight_pct, 1)} sub={t('bottomingFlow.marketInternals.stockCount', { count: summary?.universe?.spotlight_count || 0 })} color={C.acceleration} />
      </Box>
    </Box>
  );
}
